export enum DeliveryStatusEnum {
  Pending = 'pending',
  Collected = 'collected',
  InTransit = 'inTransit',
  Shipped = 'shipped',
  Returned = 'returned',
  Completed = 'completed'
}
